<template>
<div class=" sa-no-data sa-error-page sa-network-error">
    <img src="../../assets/img/page-not-found.svg" alt="Page not Found" class="sa-img-responsive w-50" />
    <h2><strong>Page does not exist</strong></h2>
    <p>Maybe because the page you are looking for is still in draft state or isnt published at all. For more information on what exactly went wrong.<span class="d-block">Please contact the form’s administrator.</span></p>
    <button type="button" class="sa-btn sa-btn-primary sa-mt15 sa-btn-large" @click="backBtn">Back to home</button>
</div>
</template>
<script>
  export default {
    data() {
      return {
      };
    },
    methods: {
        toggleBodyClass(addRemoveClass, className) {
        const el = document.body;
        if (addRemoveClass === "addClass") {
            el.classList.add(className);
        } else {
            el.classList.remove(className);
        }
        },
      backBtn() {
        this.$router.push({path: '/'})
      }
    },
    mounted() {
        this.toggleBodyClass('addClass', 'sa-error-404');
    },
    destroyed() {
        this.toggleBodyClass('removeClass', 'sa-error-404');
    },
  };
</script>